import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/basic-health/patientStatementOfConsent";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	patientStatementOfConsent: {
		id: "form.patient_statement_of_consent",
		defaultMessage: "Páciens beleegyező nyilatkozat"
	},
	signed: {
		id: "form.patient_statement_of_consent.signed_statement_of_consent",
		defaultMessage:
			"A hozzájáruló nyilatkozatot a beteg aláírásával elfogadta. (Kérjük az űrlaphoz töltse fel mellékletként az aláírt nyilatkozatot beszkennelt vagy lefotózott formában)"
	}
});

const fields: { [key: string]: FieldData } = {
	signed: {
		type: "field",
		path: ["signed"],
		label: messages.signed,
		errorMessages: genericErrorMessages,
		input: { type: "switch", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.signed }] }]
};

export const node: LeafNode = {
	id: "bh_patientStatementOfConsent",
	value: {
		schemaId: "patientStatementOfConsent",
		title: messages.patientStatementOfConsent,
		validator,
		fieldset
	}
};
